/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { useContext } from 'react';
import { StrategySchemaV2Context } from '../context/StrategySchemaV2ContextBase';

export const useStrategySchemaV2 = () => useContext(StrategySchemaV2Context);
